import { SizeProp } from '@fortawesome/fontawesome-svg-core';
import { faCircle, faCircleDot } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Dispatch, InputHTMLAttributes, SetStateAction } from 'react';
import VoxelText from '../Text/VoxelText';

export interface VoxelRadioProps
  extends Pick<InputHTMLAttributes<HTMLInputElement>, 'onMouseDown' | 'onMouseUp' | 'disabled'> {
  title: string;
  subtitle?: string;
  value: string | number;
  selectedOption: string | number;
  setSelectedOption: Dispatch<SetStateAction<string | number>>;
  disabled?: boolean;
  size?: SizeProp;
  colorClass?: string;
}

export const VoxelRadio: React.FC<VoxelRadioProps> = ({
  onMouseDown,
  onMouseUp,
  title,
  subtitle,
  disabled,
  value,
  selectedOption,
  setSelectedOption,
  size = 'lg',
  colorClass = 'text-voxel-blue-500',
}) => {
  return (
    <div
      className={`flex flex-row gap-4 ${!!subtitle?.length ? 'items-start' : 'items-center'} ${disabled ? '' : 'cursor-pointer'
        }`}
      onClick={() => setSelectedOption(value)}
      onMouseDown={onMouseDown}
      onMouseUp={onMouseUp}
    >
      <div className={`fa-layers fa-fw fa-sm ${!!subtitle?.length ? 'mt-1.5' : ''}`}>
        <FontAwesomeIcon
          icon={faCircle}
          size={size}
          className={`
          ${disabled ? 'text-voxel-gray-300' : ''}
          ${!disabled ? colorClass : ''}
          ${selectedOption !== value && disabled ? 'text-voxel-gray-300' : ''}
          ${selectedOption === value ? 'invisible' : 'visible'}
          `}
        />
        <FontAwesomeIcon
          icon={faCircleDot}
          size={size}
          className={`
            ${disabled ? 'text-voxel-gray-300' : ''}
            ${!disabled ? colorClass : ''}
            ${selectedOption !== value && disabled ? 'text-voxel-gray-300' : ''}
            ${selectedOption === value ? 'visible' : 'invisible'} 
            `}
        />
      </div>
      <div className="flex flex-col gap-0.5">
        <VoxelText variant="bread-medium" color={disabled ? 'slight' : 'dark'}>
          {title}
        </VoxelText>
        {!!subtitle?.length && (
          <VoxelText variant="bread-normal" color={disabled ? 'slight' : 'dark'}>
            {subtitle}
          </VoxelText>
        )}
      </div>
    </div>
  );
};

export default VoxelRadio;
